import(/* webpackMode: "eager" */ "/codebuild/output/src3345857214/src/src/app/global-error.tsx");
